import { Directive } from '@angular/core';
import { BrnAccordion } from '@spartan-ng/brain/accordion';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
  selector: '[hlmAccordion],hlm-accordion',
  hostDirectives: [{ directive: BrnAccordion, inputs: ['type', 'orientation'] }],
  host: { 'data-slot': 'accordion' },
})
export class HlmAccordion {
  constructor() {
    classes(() => 'block');
  }
}
